import { ReadHolidayResponseDto } from '@/api.types';
import { LOCALIZACAO_SISTEMA } from '@/shared/constants/strings';

type Props = {
  feriados: ReadHolidayResponseDto[];
};

/**
 * Lista compacta de bloqueios/feriados do mês da folha.
 */
export default function AttendanceSheetHolidaysNotice({ feriados }: Props) {
  return (
    <div className="d-flex justify-content-center">
      <span className="alert alert-warning text-start py-1 px-2" style={{ fontSize: 13 }}>
        {feriados.length === 0 ? (
          <>(Sem bloqueios esse mês)</>
        ) : (
          feriados.map((a, index) => (
            <span key={`feriado-${index}-${String(a.inicio)}`}>
              (
              {new Date(a.inicio).toLocaleDateString(LOCALIZACAO_SISTEMA, {
                month: 'numeric',
                day: 'numeric',
              })}
              ) {a.nome}
              <br className="pt-5" />
            </span>
          ))
        )}
      </span>
    </div>
  );
}
